import { useEffect } from 'react';
import { preloadRoutesWhenIdle } from '../lib/preload-routes';
import { sidebarRouteLoaders } from '../lib/route-loaders';

/** Preloads the code for each sidebar destination in `paths` once the browser is idle. */
export function usePreloadSidebarRoutes(paths: readonly string[]): void {
  // Keyed on the joined paths so a fresh array with the same destinations does
  // not restart the queue on every render.
  const key = paths.join('|');
  useEffect(() => {
    const loaders = key.split('|').flatMap((path) => {
      const loader = sidebarRouteLoaders[path];
      return loader ? [loader] : [];
    });
    return preloadRoutesWhenIdle(loaders);
  }, [key]);
}
